import React from 'react';

const defaultDuration = 155; //ms

export type TransitionTimeout = number | {appear?: number; enter?: number; exit?: number} | undefined;
export type TimeoutType = 'appear' | 'enter' | 'exit';

const defaultTimeout: TransitionTimeout = {
  appear: 0,
  enter: defaultDuration,
  exit: defaultDuration,
};

export const getTransitionDuration = (timeout: TransitionTimeout, type: TimeoutType) => {
  if (!timeout) return defaultDuration;

  if (typeof timeout === 'number') {
    return timeout;
  }

  if (typeof timeout === 'object') {
    return timeout[type] || defaultTimeout[type] || defaultDuration;
  }

  return defaultDuration;
};

export type TransitionCallback = (node: HTMLElement | null) => void;

export type TransitionRootProps = {
  in?: boolean;
  timeout?: TransitionTimeout;
  appear?: boolean;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;
  onEnter?: TransitionCallback;
  onEntered?: TransitionCallback;
  onExit?: TransitionCallback;
  onExited?: TransitionCallback;
  nodeRef?: React.Ref<HTMLElement> | undefined;
  children?: React.ReactNode;
};
